import { Mapper } from '@Features/utils/prepareSearchCriterias';
import { SearchItemOperator } from '@Types/api/common/filters';
import { TypeDict } from '@Types/index';

import { FilterForm } from './types';

export const initialValuesFilterForm: FilterForm = {
  tenderAmount: [],
  prFor: [],
  tenderFor: [],
  priority: [],
  classification: [],
  tenderExtensionType: [],
  tenderStatus: [],
};

export const filterTypes: Record<
  keyof typeof initialValuesFilterForm,
  SearchItemOperator | SearchItemOperator[]
> = {
  tenderAmount: ['ge', 'le'],
  prFor: 'in',
  tenderFor: 'in',
  priority: 'in',
  classification: 'in',
  tenderExtensionType: 'in',
  tenderStatus: 'in',
};
enum AMOUNT {
  OPTION_1 = '0.00 - 200.00',
  OPTION_2 = '200.00 - 400.00',
  OPTION_3 = '400.00 - 600.00',
  OPTION_4 = '600.00 - 800.00',
}
export const mockTenderAmount = {
  [AMOUNT.OPTION_1]: [0, 200],
  [AMOUNT.OPTION_2]: [200, 400],
  [AMOUNT.OPTION_3]: [400, 600],
  [AMOUNT.OPTION_4]: [600, 800],
};
// TODO
// const mapTenderAmount = (amountStr: string[]): number[] =>
//   amountStr.map((amount) => mockTenderAmount[amount]);
const priorityLabelToValue = (priorityLabel: string): null | 1 =>
  priorityLabel === 'Normal' ? null : 1;

const getCodeNumFromLabel =
  (dict: TypeDict[]) => (label: TypeDict['codeDesc']) =>
    dict.find((dictItem) => dictItem.codeDesc === label)!.codeNum;

const getAmountRangeFromOptions = (strOptions: string[]): number[][] => {
  return strOptions.map((opt) => opt.split('-').map((el) => parseInt(el, 10)));
};

export const getFiltersMapper =
  (
    statuses: TypeDict[],
    prForDict: TypeDict[],
    tenderFor: TypeDict[],
    calassificationDict: TypeDict[],
    tenderExtensionType: TypeDict[],
    rfqStatusDict: TypeDict[]
  ): Mapper =>
  // eslint-disable-next-line react/function-component-definition
  (key, value) => {
    if (key === 'tenderAmount') {
      return [
        'tenderAmount',
        value ? getAmountRangeFromOptions(value as string[]) : null,
      ];
    }

    if (key === 'prFor') {
      const prForValues = (value as string[]).map(
        (prForLabel) =>
          prForDict.find((dictItem) => dictItem.codeDesc === prForLabel)!
            .codeNum
      );
      return ['pRFor', prForValues];
    }

    if (key === 'tenderFor') {
      const tenderForValues = (value as string[]).map(
        (tenderForLabel) =>
          tenderFor.find((dictItem) => dictItem.codeDesc === tenderForLabel)!
            .codeNum
      );
      return ['tenderFor', tenderForValues];
    }

    if (key === 'priority') {
      const priorityValues = (value as string[]).map(priorityLabelToValue);
      return ['priorityID', priorityValues];
    }

    if (key === 'classification') {
      const classificationValues = (value as string[]).map(
        getCodeNumFromLabel(calassificationDict)
      );
      return ['classificationID', classificationValues];
    }

    if (key === 'tenderExtensionType') {
      const tenderExtensionTypeValues = (value as string[]).map(
        getCodeNumFromLabel(tenderExtensionType)
      );
      return ['extensionTypeID', tenderExtensionTypeValues];
    }

    if (key === 'tenderStatus') {
      const statusValue = (value as string[]).map(
        getCodeNumFromLabel(rfqStatusDict)
      );
      return ['statusID', statusValue];
    }

    const statusResultValue = (value as string[]).map(
      (item) => statuses.find((status) => status.codeDesc === item)!.codeNum
    );

    return ['statusId', statusResultValue];
  };
